/* ExpandableGridRowComponent.js */

"use strict";

const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./ExpandableGridRowRenderer");

class ExpandableGridRowComponent extends EventEmitter {

    constructor(configOptions) {
        super();

        this._id = _.get(configOptions, 'id', undefined);
        this._parentId = _.get(configOptions, 'parentId', '');
        this._name = _.get(configOptions, 'name', '');
        this._columnOrder = _.get(configOptions, 'columnOrder');
        this._columnComponents = _.get(configOptions, 'columnComponents');
        this._children = _.get(configOptions, 'children', []);
        this._nestedLevel = _.get(configOptions, 'nestedLevel', 0);
        this._expanded = _.get(configOptions, 'expanded', false);
        
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._id = undefined;
            this._parentId = undefined;
            this._name = undefined;
            this._columnOrder = undefined;
            this._columnComponents = undefined;
            this._children = undefined;
            this._nestedLevel = undefined;
            this._expanded = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    
    _triggerRowUserSelected(event){
        this.emit('RowUserSelected', this._rowData, event);
    }

    _triggerRowUserDoubleClicked(event){
        this.emit('RowUserDoubleClicked', this._rowData, event);
    }

    _triggerRowAction(eventData){
        let rowEvent = {
            rowId: this.getId(),
            eventData: eventData
        };
        this.emit('RowAction', rowEvent);
    }

    _triggerRowUserExpanded(){
        this.emit('RowUserExpanded', this.getExpanded(), this.getId());
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setId(newVal){
        this._id = newVal;
        this.emit('ID', this._id);
        return this;
    }
    getId(){
        return this._id;
    }

    setParentId(newVal){
        this._parentId = newVal;
        return this;
    }
    getParentId(){
        return this._parentId;
    }

    setName(newVal){
        this._name = newVal;
        this.emit('Name', this._name);
        return this;
    }
    getName(){
        return this._name;
    }

    setColumnOrder(newVal){
        this._columnOrder = newVal;
        this.emit('ColumnOrder', this._columnOrder);
        return this;
    }
    getColumnOrder(){
        return this._columnOrder;
    }

    setColumnComponents(newVal){
        this._columnComponents = newVal;
        this.emit('ColumnComponents', this._columnComponents);
        return this;
    }
    getColumnComponents(){
        return this._columnComponents;
    }

    setChildren(newVal){
        this._children = newVal;
        this.emit('Children', this._children);
        return this;
    }
    getChildren(){
        return this._children;
    }
    addChild(childId){
        this._children.push(childId);
        this.setChildren(this._children);
    }
    removeChild(childId){
        this._children.forEach((child, index) => {
            if (child === childId) {
                this._children.splice(index, 1);
            }
        });
        this.setChildren(this._children);
    }

    setNestedLevel(newVal){
        this._nestedLevel = newVal;
        this.emit('NestedLevel', this._nestedLevel);
        return this;
    }
    getNestedLevel(){
        return this._nestedLevel;
    }

    setExpanded(newVal){
        this._expanded = newVal;
        this.emit('Expanded', this._expanded);
        return this;
    }
    getExpanded(){
        return this._expanded;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ExpandableGridRowComponent;